import React from 'react';

const styles = {
  container: {
    textAlign: 'center',
    marginTop: 180,
  },
  header: {
    fontSize: 48,
    fontWeight: 100,
    margin: 20,
    lineHeight: '48px',
  },
};

export default function ErrorPage({ message }) {
  return (
    <div style={styles.container}>
      <div>
        <h1 style={styles.header}>
          Error
        </h1>
        <p>
          {message}
        </p>
      </div>
    </div>
  );
}